import React, { PureComponent } from 'react';
import { Form, FormGroup } from '../../../../components/Forms/Forms';
import { Input, Select, MultiSelect } from '../../../../components/Forms/fields';
import enums from '../../../../constants/enums';

class ChannelFiltersView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    let {
      onFilterChange,
      filtersFormState,
      amazonAccounts
    } = this.props;

    return (
      <div className="filters-container admin-payment-filters-view">
        <Form state={filtersFormState} onSubmit={()=>{}} onChange={onFilterChange}>
          <FormGroup>
            <label>Accounts:</label>
            <MultiSelect name="accounts" options={amazonAccounts} multiple/>
          </FormGroup>
          <FormGroup>
            <label>Created:</label>
            <Input name="created" type="date" placeholder="YYYY-MM-DD"/>
          </FormGroup>
          <FormGroup>
            <label>Type:</label>
            <Select name="type" options={enums.salesChannelTypes} selectLabel="-" emptyOption/>
          </FormGroup>
          <FormGroup>
            <label>Status:</label>
            <Select name="status" options={enums.salesChannelStatus} selectLabel="-" emptyOption/>
          </FormGroup>
          <FormGroup>
            <label>Order #:</label>
            <Input name="orderNumber" type="text"/>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default ChannelFiltersView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Channels/ChannelFilters/ChannelFilters.view.js